import { Contact } from '@contacts/interfaces/contact';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-booking-select-info',
  components: {},
})
export default class BookingSelectInfo extends Vue {
  @Prop(Object) readonly element: Record<string, any>;

  public onClick($event) {
    this.$emit('click', this.element);
  }

  public formatDate(date) {
    if (date) {
      return moment(String(date)).format('DD.MM.YYYY');
    }
  }
}
